interface BaseIconProps {
  color?: string;
  iconWidth?: number;
  iconHeight?: number;
}

const TYArrowDown = ({ color }: BaseIconProps) => (
  <svg
    width="12"
    height="19"
    viewBox="0 0 12 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.68998 12.0685L11.0552 12.0685C11.7797 12.0685 12.1536 12.9565 11.6278 13.4823L6.61497 18.4951C6.2878 18.8223 5.77367 18.8223 5.45818 18.4834L0.433704 13.459C-0.0804274 12.9448 0.293487 12.0568 1.01795 12.0568L4.38317 12.0568L4.35306 0.672927L7.68998 0.664098L7.68998 12.0685Z"
      fill={color || 'currentColor'}
    />
  </svg>
);

const TYArrowUp = ({ color }: BaseIconProps) => (
  <svg
    width="12"
    height="19"
    viewBox="0 0 12 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.37802 6.99963L1.01279 6.99963C0.288328 6.99963 -0.0855869 6.11159 0.44023 5.58577L5.45302 0.572981C5.78019 0.245806 6.29432 0.245806 6.60981 0.584666L11.6343 5.60914C12.1484 6.12327 11.7745 7.01132 11.05 7.01132L7.68482 7.01132L7.71494 18.3952L4.37802 18.404L4.37802 6.99963Z"
      fill={color || 'currentColor'}
    />
  </svg>
);

const TYClock = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.99 0C4.47 0 0 4.48 0 10C0 15.52 4.47 20 9.99 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 9.99 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18ZM9.78 5H9.72C9.32 5 9 5.32 9 5.72V10.44C9 10.79 9.18 11.12 9.49 11.3L13.64 13.79C13.98 13.99 14.42 13.89 14.62 13.55C14.83 13.21 14.72 12.76 14.37 12.56L10.5 10.26V5.72C10.5 5.32 10.18 5 9.78 5Z"
      fill="#0058D0"
    />
  </svg>
);

const TYDashboardIcon = ({ color }: BaseIconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill={color || 'currentColor'}
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="4"
      height="4"
      rx="2"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 9 11)"
      fill=""
    />
    <rect
      width="4"
      height="6"
      rx="1"
      transform="matrix(-1.31134e-07 1 1 1.31134e-07 12 13)"
      fill=""
    />
    <rect
      width="4"
      height="8"
      rx="1"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 18 11)"
      fill=""
    />
    <rect
      width="4"
      height="6"
      rx="1"
      transform="matrix(-1.31134e-07 1 1 1.31134e-07 5 13)"
      fill=""
    />
  </svg>
);

const TYDropdownArrow = ({ color }: BaseIconProps) => (
  <svg
    width="12"
    height="8"
    viewBox="0 0 12 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.18012e-07 1.31587C9.08122e-07 1.54212 0.0811738 1.72723 0.22999 1.88492L5.37091 7.2189C5.56032 7.40402 5.75648 7.5 6 7.5C6.23675 7.5 6.44645 7.41087 6.62232 7.2189L11.77 1.88492C11.9188 1.72723 12 1.54212 12 1.31587C12 0.856513 11.6483 0.5 11.2018 0.5C10.9853 0.5 10.7756 0.595984 10.6201 0.746817L5.99324 5.55289L1.37993 0.746816C1.21759 0.589128 1.02142 0.5 0.798197 0.5C0.351748 0.499999 9.38091e-07 0.856513 9.18012e-07 1.31587Z"
      fill={color || 'currentColor'}
    />
  </svg>
);

const TYDropdownDots = ({ color }: BaseIconProps) => (
  <svg
    width="4"
    height="12"
    viewBox="0 0 4 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.5 10.5C0.5 11.325 1.175 12 2 12C2.825 12 3.5 11.325 3.5 10.5C3.5 9.675 2.825 9 2 9C1.175 9 0.5 9.675 0.5 10.5ZM0.5 1.5C0.5 2.325 1.175 3 2 3C2.825 3 3.5 2.325 3.5 1.5C3.5 0.675 2.825 -1.01629e-07 2 -6.55671e-08C1.175 -2.95052e-08 0.5 0.675 0.5 1.5ZM0.5 6C0.5 6.825 1.175 7.5 2 7.5C2.825 7.5 3.5 6.825 3.5 6C3.5 5.175 2.825 4.5 2 4.5C1.175 4.5 0.5 5.175 0.5 6Z"
      fill={color || 'currentColor'}
    />
  </svg>
);

const TYFilterIcon = () => (
  <svg
    width="16"
    height="12"
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="16" height="2" rx="1" fill="#0058D0" />
    <path
      d="M0 6C0 5.44772 0.447715 5 1 5L4.64706 5C5.19935 5 5.64706 5.44772 5.64706 6C5.64706 6.55228 5.19934 7 4.64706 7H0.999999C0.447714 7 0 6.55228 0 6Z"
      fill="#0058D0"
    />
    <path
      d="M11.2941 6C11.2941 5.44772 11.7418 5 12.2941 5L15 5C15.5522 5 15.9999 5.44772 15.9999 6C15.9999 6.55228 15.5522 7 14.9999 7H12.2941C11.7418 7 11.2941 6.55228 11.2941 6Z"
      fill="#0058D0"
    />
    <path
      d="M8.4706 8.5C7.9508 8.5 7.52942 8.07862 7.52942 7.55882L7.52942 4.44118C7.52942 3.92138 7.9508 3.5 8.4706 3.5C8.99039 3.5 9.41177 3.92138 9.41177 4.44118L9.41177 7.55882C9.41177 8.07862 8.99039 8.5 8.4706 8.5Z"
      fill="#0058D0"
    />
    <rect y="10" width="16" height="2" rx="1" fill="#0058D0" />
  </svg>
);

const TYMainLogoIcon = ({ iconWidth, iconHeight, color }: BaseIconProps) => (
  <svg
    width={iconWidth || 9}
    height={iconHeight || 10}
    viewBox="0 0 9 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.895264 5.19274V1.95465C0.895264 1.07845 1.84764 0.507026 2.6286 0.964169L5.4286 2.58322L8.2286 4.20226C8.9905 4.64036 8.9905 5.74512 8.2286 6.20226L5.4286 7.82131L2.6286 9.44036C1.86669 9.87845 0.895264 9.32607 0.895264 8.44988V5.21179V5.19274Z"
      fill={color || '#231F20'}
    />
  </svg>
);

const TYManagePlayersIcon = ({ color }: BaseIconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20ZM10.4472 15.2764L15.2111 12.8944C15.9482 12.5259 15.9482 11.4741 15.2111 11.1056L10.4472 8.72361C9.78231 8.39116 9 8.87465 9 9.61803V14.382C9 15.1253 9.78231 15.6088 10.4472 15.2764Z"
      fill={color || 'currentColor'}
    />
  </svg>
);

const TYManageUsersIcon = ({ color }: BaseIconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 8.91432C4.55 8.91432 5 8.45146 5 7.88575C5 7.32003 4.55 6.85718 4 6.85718C3.45 6.85718 3 7.32003 3 7.88575C3 8.45146 3.45 8.91432 4 8.91432ZM5 12C5 12.5657 4.55 13.0285 4 13.0285C3.45 13.0285 3 12.5657 3 12C3 11.4343 3.45 10.9714 4 10.9714C4.55 10.9714 5 11.4343 5 12ZM5 16.1142C5 16.6799 4.55 17.1428 4 17.1428C3.45 17.1428 3 16.6799 3 16.1142C3 15.5485 3.45 15.0856 4 15.0856C4.55 15.0856 5 15.5485 5 16.1142ZM21 12C21 12.5657 20.55 13.0285 20 13.0285H8C7.45 13.0285 7 12.5657 7 12C7 11.4343 7.45 10.9714 8 10.9714H20C20.55 10.9714 21 11.4343 21 12ZM20 17.1428C20.55 17.1428 21 16.6799 21 16.1142C21 15.5485 20.55 15.0856 20 15.0856H8C7.45 15.0856 7 15.5485 7 16.1142C7 16.6799 7.45 17.1428 8 17.1428H20ZM8 8.91432C7.45 8.91432 7 8.45146 7 7.88575C7 7.32003 7.45 6.85718 8 6.85718H20C20.55 6.85718 21 7.32003 21 7.88575C21 8.45146 20.55 8.91432 20 8.91432H8Z"
      fill={color || 'currentColor'}
    />
  </svg>
);

const TYPlusIcon = ({ color }: BaseIconProps) => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill={color || 'currentColor'}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_320_1312)">
      <rect
        x="17"
        y="10"
        width="3"
        height="15"
        rx="1.5"
        fill={color || 'currentColor'}
      />
      <rect
        x="11"
        y="19"
        width="3"
        height="15"
        rx="1.5"
        transform="rotate(-90 11 19)"
        fill={color || 'currentColor'}
      />
    </g>
    <defs>
      <filter
        id="filter0_d_320_1312"
        x="-5"
        y="-3"
        width="46"
        height="46"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="2.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.14902 0 0 0 0 0.2 0 0 0 0 0.301961 0 0 0 0.03 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_320_1312"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_320_1312"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

const TYSearchIcon = () => (
  <svg
    width="14"
    height="13"
    viewBox="0 0 14 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.0242 8.39376H9.43101L9.22078 8.19116C10.1218 7.14063 10.5873 5.70742 10.332 4.18415C9.97911 2.09811 8.23721 0.432276 6.13493 0.177148C2.95898 -0.213047 0.286075 2.45829 0.676499 5.63238C0.931777 7.73343 2.59859 9.4743 4.68585 9.82698C6.21001 10.0821 7.64407 9.61687 8.69521 8.71642L8.89793 8.92653V9.51932L12.0889 12.7084C12.3967 13.0161 12.8998 13.0161 13.2076 12.7084C13.5154 12.4008 13.5154 11.898 13.2076 11.5904L10.0242 8.39376ZM5.51926 8.39377C3.64973 8.39377 2.14059 6.88552 2.14059 5.01708C2.14059 3.14865 3.64973 1.64039 5.51926 1.64039C7.38879 1.64039 8.89793 3.14865 8.89793 5.01708C8.89793 6.88552 7.38879 8.39377 5.51926 8.39377Z"
      fill="#384A78"
    />
  </svg>
);

const TYSettingsIcon = ({ color }: BaseIconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.14231 15.9693C3.74947 15.2682 4.24298 14.3902 4.73702 13.7608C6 13 6 11 4.73703 10.2C4.24298 9.57053 3.94597 8.65109 4.3388 7.95L4.73702 6.96932C5.12986 6.26822 5.90117 5.88882 6.67725 6.01494C6.71273 6.01454 6.74852 6.01416 6.78457 6.01378C8.09259 5.99992 9.74954 5.98235 9.74954 4.8C10.0316 4.0444 10.6236 3 11.4093 3H12.5987C13.3844 3 13.9764 4.04441 14.2585 4.8C14.2585 6.01494 16 6.01494 17.3308 6.01494C18.1069 5.88882 18.8782 6.26822 19.271 6.96931L19.8657 8.03069C20.2586 8.73178 19.7124 9.57053 19.2183 10.2C18 11 18 13 19.2183 13.7608C19.7124 14.3902 20.2586 15.2682 19.8657 15.9693L19.271 17.0307C18.8881 17.714 17.7973 17.536 17.0237 17.4097C17.0035 17.4065 16.9836 17.4032 16.9639 17.4C15.8086 17.4 14.371 18.5 14.371 19.7458C14.0889 20.5014 13.3844 21 12.5987 21H11.4093C10.6236 21 9.91909 20.5014 9.63705 19.7458C9.63705 18.5 8.5 17.4 7.04417 17.4C7.02447 17.4032 7.00453 17.4065 6.98438 17.4097C6.21077 17.536 5.11989 17.714 4.73702 17.0307L4.14231 15.9693ZM12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z"
      fill={color || 'currentColor'}
    />
  </svg>
);

const TYUserIcon = ({ color }: BaseIconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 3C11.66 3 13 4.34 13 6C13 7.66 11.66 9 10 9C8.34 9 7 7.66 7 6C7 4.34 8.34 3 10 3ZM10 17.2C7.5 17.2 5.29 15.92 4 13.98C4.03 11.99 8 10.9 10 10.9C11.99 10.9 15.97 11.99 16 13.98C14.71 15.92 12.5 17.2 10 17.2Z"
      fill={color || 'currentColor'}
    />
  </svg>
);

const TYPlayerBack = ({ color, iconWidth, iconHeight }: BaseIconProps) => (
  <svg
    width={iconWidth || 23}
    height={iconHeight || 24}
    viewBox="0 0 23 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.04237 4.96237C5.32442 4.53465 5.32442 3.46535 6.04237 3.03763L10.8885 0.150536C11.6065 -0.277182 12.5039 0.257467 12.5039 1.1129V2.04518C18.1085 2.55225 22.5 7.26328 22.5 13C22.5 19.0751 17.5751 24 11.5 24C5.42487 24 0.5 19.0751 0.5 13C0.5 12.4477 0.947716 12 1.5 12C2.05228 12 2.5 12.4477 2.5 13C2.5 17.9706 6.52944 22 11.5 22C16.4706 22 20.5 17.9706 20.5 13C20.5 8.36877 17.002 4.55457 12.5039 4.05535V6.8871C12.5039 7.74253 11.6065 8.27718 10.8885 7.84946L6.04237 4.96237Z"
      fill={color || '#424242'}
    />
    <path
      d="M10.0091 10.0579V16H8.92917V11.1012H8.89424L7.5 11.9856V11.0029L8.98156 10.0579H10.0091Z"
      id="number-1"
      fill={color || '#424242'}
    />
    <path
      id="number-5"
      d="M13.3606 16C12.9725 16 12.6252 15.9277 12.3186 15.7832C12.012 15.6368 11.7684 15.4364 11.588 15.1821C11.4094 14.9277 11.3144 14.6368 11.3027 14.3092H12.3506C12.37 14.552 12.4757 14.7505 12.6679 14.9046C12.86 15.0568 13.0909 15.1329 13.3606 15.1329C13.5721 15.1329 13.7604 15.0848 13.9253 14.9884C14.0902 14.8921 14.2202 14.7582 14.3153 14.5867C14.4104 14.4152 14.457 14.2197 14.455 14C14.457 13.7765 14.4094 13.578 14.3124 13.4046C14.2154 13.2312 14.0825 13.0954 13.9137 12.9971C13.7448 12.8969 13.5508 12.8468 13.3315 12.8468C13.153 12.8449 12.9774 12.8776 12.8047 12.9451C12.632 13.0125 12.4952 13.1012 12.3942 13.211L11.4192 13.052L11.7306 10H15.1054V10.896H12.6242L12.4525 12.4653H12.4874C12.598 12.3362 12.7542 12.2293 12.956 12.1445C13.1578 12.0578 13.379 12.0145 13.6197 12.0145C13.9806 12.0145 14.3027 12.0992 14.586 12.2688C14.8693 12.4364 15.0925 12.6676 15.2555 12.9624C15.4185 13.2572 15.5 13.5944 15.5 13.974C15.5 14.3651 15.4088 14.7139 15.2264 15.0202C15.0459 15.3247 14.7946 15.5645 14.4725 15.7399C14.1523 15.9133 13.7817 16 13.3606 16Z"
      fill={color || '#424242'}
    />
  </svg>
);

const TYPlayerLoading = ({ color }: BaseIconProps) => (
  <svg viewBox="0 0 50 50">
    <circle
      cx="25"
      cy="25"
      r="20"
      fill="none"
      strokeWidth="5"
      stroke={color || 'currentColor'}
    ></circle>
  </svg>
);

const TYPlayerPause = ({ iconHeight, iconWidth }: BaseIconProps) => (
  <svg
    width={iconWidth || 10}
    height={iconHeight || 12}
    viewBox="0 0 10 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.203125" width="3.6" height="12" rx="1.8" fill="white" />
    <rect x="6.20312" width="3.6" height="12" rx="1.8" fill="white" />
  </svg>
);

const TYPlayerForward = ({ color, iconHeight, iconWidth }: BaseIconProps) => (
  <svg
    width={iconWidth || 23}
    height={iconHeight || 24}
    viewBox="0 0 23 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.9615 4.96237C17.6795 4.53465 17.6795 3.46535 16.9615 3.03763L12.1154 0.150536C11.3974 -0.277182 10.5 0.257467 10.5 1.1129V2.04484C4.8935 2.55007 0.5 7.26196 0.5 13C0.5 19.0751 5.42487 24 11.5 24C17.5751 24 22.5 19.0751 22.5 13C22.5 12.4477 22.0523 12 21.5 12C20.9477 12 20.5 12.4477 20.5 13C20.5 17.9706 16.4706 22 11.5 22C6.52944 22 2.5 17.9706 2.5 13C2.5 8.36745 6.00005 4.55237 10.5 4.05493V6.8871C10.5 7.74253 11.3974 8.27718 12.1154 7.84946L16.9615 4.96237Z"
      fill={color || '#424242'}
    />
    <path
      d="M10.0091 10.0579V16H8.92917V11.1012H8.89424L7.5 11.9856V11.0029L8.98156 10.0579H10.0091Z"
      fill={color || '#424242'}
    />
    <path
      d="M13.3606 16C12.9725 16 12.6252 15.9277 12.3186 15.7832C12.012 15.6368 11.7684 15.4364 11.588 15.1821C11.4094 14.9277 11.3144 14.6368 11.3027 14.3092H12.3506C12.37 14.552 12.4757 14.7505 12.6679 14.9046C12.86 15.0568 13.0909 15.1329 13.3606 15.1329C13.5721 15.1329 13.7604 15.0848 13.9253 14.9884C14.0902 14.8921 14.2202 14.7582 14.3153 14.5867C14.4104 14.4152 14.457 14.2197 14.455 14C14.457 13.7765 14.4094 13.578 14.3124 13.4046C14.2154 13.2312 14.0825 13.0954 13.9137 12.9971C13.7448 12.8969 13.5508 12.8468 13.3315 12.8468C13.153 12.8449 12.9774 12.8776 12.8047 12.9451C12.632 13.0125 12.4952 13.1012 12.3942 13.211L11.4192 13.052L11.7306 10H15.1054V10.896H12.6242L12.4525 12.4653H12.4874C12.598 12.3362 12.7542 12.2293 12.956 12.1445C13.1578 12.0578 13.379 12.0145 13.6197 12.0145C13.9806 12.0145 14.3027 12.0992 14.586 12.2688C14.8693 12.4364 15.0925 12.6676 15.2555 12.9624C15.4185 13.2572 15.5 13.5944 15.5 13.974C15.5 14.3651 15.4088 14.7139 15.2264 15.0202C15.0459 15.3247 14.7946 15.5645 14.4725 15.7399C14.1523 15.9133 13.7817 16 13.3606 16Z"
      fill={color || '#424242'}
    />
  </svg>
);

const TYPlayerVolume = ({ color, iconHeight, iconWidth }: BaseIconProps) => (
  <svg
    width={iconWidth || 17}
    height={iconHeight || 14}
    viewBox="0 0 17 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 1.96163C10 1.14475 9.07361 0.672493 8.41254 1.15238L4.375 4.08333L1.13216 3.65095C0.53268 3.57102 0 4.03739 0 4.64218V9.35782C0 9.96261 0.53268 10.429 1.13216 10.349L4.375 9.91667L8.41254 12.8476C9.07361 13.3275 10 12.8553 10 12.0384V1.96163Z"
      fill={color || '#424242'}
    />
    <path
      d="M11 12C13.7614 12 16 9.76142 16 7C16 4.23858 13.7614 2 11 2"
      stroke={color || '#424242'}
    />
    <path
      d="M11 10C12.6569 10 14 8.65685 14 7C14 5.34315 12.6569 4 11 4"
      stroke={color || '#424242'}
    />
  </svg>
);

const TYPlayerPlayback = ({ color, iconHeight, iconWidth }: BaseIconProps) => (
  <svg
    width={iconWidth || 15}
    height={iconHeight || 12}
    viewBox="0 0 15 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.32258 0V12H2.90323V2.5L1.93548 3L0 4V1.5L2.90323 0H5.32258Z"
      fill={color || '#0058D0'}
    />
    <path
      d="M9.67742 4L11.129 6.5L12.5806 4H15L12.5806 8L15 12H12.7389L11.129 9.5L9.67742 12H7.28903L9.67742 8L7.25806 4H9.67742Z"
      fill={color || '#0058D0'}
    />
  </svg>
);

const TYPlayerActivateMask = ({
  color,
  iconHeight,
  iconWidth,
}: BaseIconProps) => (
  <svg
    width={iconWidth || 8}
    height={iconHeight || 8}
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.480253 8L4.80254 8C5.06777 8 5.28279 7.7676 5.28279 7.48093C5.28279 7.19426 5.06777 7.01439 4.80254 7.01439L1.75091 7.00037L4.75141 3.75037C4.93896 3.54766 4.93896 3.20308 4.75141 3.00037C4.56386 2.79766 4.18884 2.79766 4.00129 3.00037L1.00079 6.25037L1.00079 3.00037C1.00079 2.71369 0.76594 2.50037 0.500703 2.50037C0.235466 2.50037 -4.91531e-07 2.71369 -5.16592e-07 3.00037L-9.08296e-07 7.48093C-1.88703e-06 7.7676 0.215016 8 0.480253 8ZM7.50187 0.000404791L4.49942 1.70806e-07C4.23418 1.47619e-07 3.99933 0.213326 3.99933 0.5C3.99933 0.786674 4.23418 1 4.49942 1L7.00179 1.00037L7.00179 3.25C7.00179 3.53667 7.23663 3.75 7.50187 3.75C7.76711 3.75 8 3.53667 8 3.25L8 0.500366C8 0.213692 7.76711 0.000404814 7.50187 0.000404791Z"
      fill={color || '#0058D0'}
    />
  </svg>
);

const TYPlayerPreferences = ({
  color,
  iconHeight,
  iconWidth,
}: BaseIconProps) => (
  <svg
    width={iconWidth || 28}
    height={iconHeight || 28}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.40182 12.1333C7.37516 12.1333 6.53516 12.9733 6.53516 14C6.53516 15.0266 7.37516 15.8666 8.40182 15.8666C9.42849 15.8666 10.2685 15.0266 10.2685 14C10.2685 12.9733 9.42849 12.1333 8.40182 12.1333ZM19.6018 12.1333C18.5752 12.1333 17.7352 12.9733 17.7352 14C17.7352 15.0266 18.5752 15.8666 19.6018 15.8666C20.6285 15.8666 21.4685 15.0266 21.4685 14C21.4685 12.9733 20.6285 12.1333 19.6018 12.1333ZM14.0018 12.1333C12.9752 12.1333 12.1352 12.9733 12.1352 14C12.1352 15.0266 12.9752 15.8666 14.0018 15.8666C15.0285 15.8666 15.8685 15.0266 15.8685 14C15.8685 12.9733 15.0285 12.1333 14.0018 12.1333Z"
      fill={color || '#0058D0'}
    />
  </svg>
);

const TYPlayerDynamicClose = ({
  color,
  iconHeight,
  iconWidth,
}: BaseIconProps) => (
  <svg
    width={iconWidth || 16}
    height={iconHeight || 16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.960506 16L9.60507 16C10.1355 16 10.5656 15.5352 10.5656 14.9618C10.5656 14.3884 10.1355 14.0287 9.60507 14.0287L3.50182 14.0006L9.50282 7.50034C9.87793 7.09491 9.87793 6.40571 9.50282 6.00027C9.12772 5.59484 8.37767 5.59484 8.00257 6.00027L2.00157 12.5006L2.00157 6.00027C2.00157 5.4269 1.53188 5.00023 1.00141 5.00023C0.470931 5.00023 -9.83019e-07 5.4269 -1.03314e-06 6.00027L-1.81659e-06 14.9618C-1.86671e-06 15.5352 0.430032 16 0.960506 16ZM15.0037 7.81142e-05L7.00241 1.6708e-07C6.47193 1.20704e-07 6.00224 0.426671 6.00224 1.00005C6.00224 1.57342 6.47193 2.00009 7.00241 2.00009L14.0036 2.00009L14.0036 9.00041C14.0036 9.57379 14.4733 10.0005 15.0037 10.0005C15.5342 10.0005 16 9.57379 16 9.00041L16 1.00005C16 0.426672 15.5342 7.81606e-05 15.0037 7.81142e-05Z"
      fill={color || '#0058D0'}
    />
  </svg>
);

const TYPlayerDynamicPreferences = ({
  color,
  iconHeight,
  iconWidth,
}: BaseIconProps) => (
  <svg
    width={iconWidth || 20}
    height={iconHeight || 20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5245 0.145384C12.4245 0.0519316 12.2915 -0.000142724 12.1532 2.9381e-07H12.1522H7.84523C7.70698 -0.000142724 7.574 0.0519316 7.47397 0.145384C7.37394 0.238837 7.31456 0.366467 7.3082 0.50171L7.2311 1.36493C7.16139 2.14539 6.63611 2.79777 5.95462 3.18449C5.28861 3.56243 4.48405 3.68075 3.78752 3.36255L2.93574 2.97344C2.81291 2.91129 2.67033 2.89792 2.53768 2.93613C2.40504 2.97433 2.29255 3.06116 2.22364 3.17854L0.0733936 6.82935C0.00452679 6.94624 -0.0158178 7.08458 0.0165693 7.21575C0.0489563 7.34693 0.131596 7.46088 0.24739 7.53405L1.01577 8.06104C1.64281 8.4911 1.9423 9.24577 1.94228 10.0061C1.94226 10.7667 1.64258 11.5215 1.01525 11.9515L0.246316 12.4786C0.130238 12.5518 0.0474 12.6659 0.0150001 12.7973C-0.0173999 12.9287 0.0031271 13.0673 0.0723196 13.1843L2.22472 16.8225C2.29381 16.9397 2.40637 17.0263 2.539 17.0643C2.67163 17.1023 2.81411 17.0888 2.93681 17.0266L3.78789 16.6378C4.48482 16.3194 5.28984 16.4379 5.95611 16.8163C6.63739 17.2031 7.16245 17.8555 7.23215 18.6359L7.30928 19.4993C7.3159 19.6344 7.3754 19.7618 7.4754 19.855C7.5754 19.9482 7.70823 20.0002 7.8463 20H12.1532C12.2913 20.0002 12.4241 19.9482 12.5241 19.855C12.6242 19.7618 12.6836 19.6344 12.6903 19.4993L12.7675 18.6345C12.8372 17.8549 13.3731 17.1978 14.0534 16.8107C14.72 16.4313 15.5153 16.3197 16.2129 16.6383L17.0627 17.0266C17.1855 17.0884 17.3278 17.1016 17.4602 17.0634C17.5926 17.0252 17.7049 16.9386 17.7738 16.8215L19.9272 13.1854C19.9967 13.0683 20.0175 12.9295 19.985 12.7978C19.9526 12.6661 19.8696 12.5518 19.7532 12.4786L18.9848 11.9523C18.3572 11.5225 18.0562 10.7802 18.0569 10.0195C18.0576 9.25935 18.3556 8.49226 18.9826 8.06241L19.7532 7.53405C19.8693 7.46087 19.9521 7.34671 19.9845 7.21529C20.0169 7.08387 19.9964 6.94528 19.9272 6.82829L17.7738 3.17854C17.7049 3.06143 17.5926 2.97479 17.4602 2.9366C17.3278 2.89841 17.1855 2.91161 17.0627 2.97344L16.211 3.36255C15.5144 3.68075 14.7099 3.56243 14.0439 3.18449C13.3624 2.79777 12.8371 2.14539 12.7674 1.36493L12.6903 0.50171C12.6839 0.366467 12.6245 0.238837 12.5245 0.145384ZM10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z"
      fill={color || '#0058D0'}
    />
  </svg>
);

const TYSelectIcon = () => (
  <svg
    width="10"
    height="8"
    viewBox="0 0 10 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.848 6.6432C5.45633 7.26987 4.54367 7.26987 4.152 6.6432L0.956248 1.53C0.539968 0.86395 1.01881 3.2746e-07 1.80425 3.96124e-07L8.19575 9.54888e-07C8.98119 1.02355e-06 9.46003 0.863952 9.04375 1.53L5.848 6.6432Z"
      fill="#A1A1AA"
    />
  </svg>
);

const TYNewUserIcon = ({ iconHeight, iconWidth }: BaseIconProps) => (
  <svg
    width={iconWidth}
    height={iconHeight}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="48" height="48" rx="24" fill="#E6F6FE" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.0004 12.8C26.6564 12.8 28.8004 14.944 28.8004 17.6C28.8004 20.256 26.6564 22.4 24.0004 22.4C21.3444 22.4 19.2004 20.256 19.2004 17.6C19.2004 14.944 21.3444 12.8 24.0004 12.8ZM24.0004 35.52C20.0004 35.52 16.4644 33.472 14.4004 30.368C14.4484 27.184 20.8004 25.44 24.0004 25.44C27.1844 25.44 33.5524 27.184 33.6004 30.368C31.5364 33.472 28.0004 35.52 24.0004 35.52Z"
      fill="#0058D0"
    />
  </svg>
);

const TYUserListIcon = ({ color }: BaseIconProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 0C3.584 0 0 3.584 0 8C0 12.416 3.584 16 8 16C12.416 16 16 12.416 16 8C16 3.584 12.416 0 8 0ZM8 2.4C9.328 2.4 10.4 3.472 10.4 4.8C10.4 6.128 9.328 7.2 8 7.2C6.672 7.2 5.6 6.128 5.6 4.8C5.6 3.472 6.672 2.4 8 2.4ZM8 13.76C6 13.76 4.232 12.736 3.2 11.184C3.224 9.592 6.4 8.72 8 8.72C9.592 8.72 12.776 9.592 12.8 11.184C11.768 12.736 10 13.76 8 13.76Z"
      fill={color}
    />
  </svg>
);

const TYCopyIcon = () => (
  <svg
    width="20"
    height="22"
    viewBox="0 0 20 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1"
      y="7"
      width="12"
      height="14"
      rx="1"
      fill="#7FAAE6"
      stroke="#0058D0"
      strokeWidth="2"
    />
    <path
      d="M18 2H8L8 7H6V2C6 0.895431 6.89543 0 8 0H18C19.1046 0 20 0.895431 20 2V14C20 15.1046 19.1046 16 18 16H13V14H18V2Z"
      fill="#0058D0"
    />
  </svg>
);

const TYCopiedIcon = () => (
  <svg
    width="20"
    height="22"
    viewBox="0 0 20 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1"
      y="7"
      width="12"
      height="14"
      rx="1"
      fill="#7FAAE5"
      stroke="white"
      strokeWidth="2"
    />
    <path
      d="M18 2H8L8 7H6V2C6 0.895431 6.89543 0 8 0H18C19.1046 0 20 0.895431 20 2V14C20 15.1046 19.1046 16 18 16H13V14H18V2Z"
      fill="white"
    />
  </svg>
);

const TYEmailMathesIcon = ({ color }: BaseIconProps) => (
  <svg
    width="10"
    height="8"
    viewBox="0 0 10 8"
    fill="#61C454"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.99963 1.38618L3.76831 8L-0.000366211 4L1.30565 2.61382L3.76831 5.22763L8.69361 0L9.99963 1.38618Z"
      fill={color}
    />
  </svg>
);

const TYShowPasswordIcon = ({ color }: BaseIconProps) => (
  <svg
    width="10"
    height="8"
    viewBox="0 0 10 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.99963 4C8.99963 5.46011 7.42864 6.9999 4.99988 7C3.89537 6.9999 3 5.65679 3 4C3 2.34315 3.89543 1 5 1C5.00108 1 5.00216 0.999999 5.00324 1C5.00204 1 5.00083 1 4.99963 1C2.57073 1 0.999634 2.53984 0.999634 4C0.999634 5.46016 2.57073 7 4.99963 7C4.99972 7 4.9998 7 4.99988 7C4.99992 7 4.99996 7 5 7C6.10457 7 7 5.65685 7 4C7 2.34476 6.10632 1.00262 5.00324 1C7.43009 1.00152 8.99963 2.54057 8.99963 4ZM9.99963 4C9.99963 6.20914 7.76106 8 4.99963 8C2.23821 8 -0.000366211 6.20914 -0.000366211 4C-0.000366211 1.79086 2.23821 0 4.99963 0C7.76106 0 9.99963 1.79086 9.99963 4Z"
      fill={color}
    />
  </svg>
);

const TYTableDropdownIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 11C7 11.55 7.45 12 8 12C8.55 12 9 11.55 9 11C9 10.45 8.55 10 8 10C7.45 10 7 10.45 7 11ZM7 5C7 5.55 7.45 6 8 6C8.55 6 9 5.55 9 5C9 4.45 8.55 4 8 4C7.45 4 7 4.45 7 5ZM7 8C7 8.55 7.45 9 8 9C8.55 9 9 8.55 9 8C9 7.45 8.55 7 8 7C7.45 7 7 7.45 7 8Z"
      fill="#A1A1AA"
    />
    <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" stroke="#A1A1AA" />
  </svg>
);

const TYTableDropdownPause = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="4" y="4" width="3" height="8" fill="#FFC700" />
    <rect x="9" y="4" width="3" height="8" fill="#FFC700" />
  </svg>
);

const TYTableDropdownPlay = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.4265 8.87416L5.48564 12.1746C4.81911 12.5449 4 12.063 4 11.3005V4.69951C4 3.93703 4.81911 3.45506 5.48564 3.82536L11.4265 7.12584C12.1123 7.50685 12.1123 8.49315 11.4265 8.87416Z"
      fill="#61C454"
      stroke="#61C454"
      strokeMiterlimit="16"
      strokeLinecap="square"
    />
  </svg>
);

const TYPublisherArrowDown = () => (
  <svg
    width="10"
    height="8"
    viewBox="0 0 10 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.848 6.6432C5.45633 7.26987 4.54367 7.26987 4.152 6.6432L0.956249 1.53C0.539968 0.86395 1.01881 1.68514e-07 1.80425 2.37179e-07L8.19575 7.95942e-07C8.98119 8.64607e-07 9.46003 0.863952 9.04375 1.53L5.848 6.6432Z"
      fill="#7E97B8"
    />
  </svg>
);

const TYPublisherArrowUp = () => (
  <svg
    width="10"
    height="8"
    viewBox="0 0 10 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.152 1.3568C4.54367 0.730128 5.45633 0.730129 5.848 1.3568L9.04375 6.47C9.46003 7.13605 8.98119 8 8.19575 8L1.80425 8C1.01881 8 0.53997 7.13605 0.95625 6.47L4.152 1.3568Z"
      fill="#7E97B8"
    />
  </svg>
);

const TYTableStaticType = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.923077 0H14.4615C14.9713 0 15.3846 0.421379 15.3846 0.941176V14.4314C15.3846 14.9512 14.9713 15.3725 14.4615 15.3725H0.923077C0.413276 15.3725 0 14.9512 0 14.4314V0.941176C0 0.421379 0.413276 0 0.923077 0ZM2.35905 4.86568C2.35905 4.58245 2.62436 4.35286 2.95164 4.35286H12.4331C12.7604 4.35286 13.0257 4.58245 13.0257 4.86568V10.5067C13.0257 10.7899 12.7604 11.0195 12.4331 11.0195H2.95164C2.62436 11.0195 2.35905 10.7899 2.35905 10.5067V4.86568ZM9.61831 7.46415C9.81585 7.56284 9.81585 7.80956 9.61831 7.90825L6.95164 9.24061C6.7541 9.3393 6.5072 9.21594 6.5072 9.01856V6.35384C6.5072 6.15645 6.7541 6.03309 6.95164 6.13179L9.61831 7.46415Z"
      fill="#7E97B8"
    />
  </svg>
);

const TYTableDynamicType = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2285_6652)">
      <rect width="16" height="16" fill="white" />
      <path
        d="M7.55654 9.42177L7.55653 9.42176C6.98859 9.07301 6.37182 9.54189 6.37182 10.1076V13.2254C6.37182 13.7911 6.98859 14.26 7.55653 13.9112L7.55654 13.9112L10.095 12.3524C10.095 12.3524 10.095 12.3524 10.095 12.3524C10.6008 12.0417 10.6008 11.2913 10.095 10.9806C10.095 10.9806 10.095 10.9806 10.095 10.9806L7.55654 9.42177ZM1.16669 9.2665C1.16669 9.22895 1.1807 9.2012 1.19619 9.18473C1.21118 9.16878 1.22342 9.1665 1.23079 9.1665H14.7693C14.7766 9.1665 14.7889 9.16879 14.8039 9.18472C14.8193 9.2012 14.8334 9.22894 14.8334 9.2665V14.0665C14.8334 14.1041 14.8193 14.1318 14.8039 14.1483C14.7889 14.1642 14.7766 14.1665 14.7693 14.1665H1.23079C1.22342 14.1665 1.21118 14.1642 1.19619 14.1483C1.1807 14.1318 1.16669 14.1041 1.16669 14.0665V9.2665Z"
        fill="#7E97B8"
        stroke="#7E97B8"
      />
      <path
        opacity="0.9"
        d="M1.30768 14.6865V1.31396H14.6923V14.6865H1.30768Z"
        stroke="#7E97B8"
        strokeWidth="2"
      />
    </g>
    <defs>
      <clipPath id="clip0_2285_6652">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const TYManagePublishers = ({ color }: BaseIconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 5C13.66 5 15 6.32113 15 7.95774C15 9.59436 13.66 10.9155 12 10.9155C10.34 10.9155 9 9.59436 9 7.95774C9 6.32113 10.34 5 12 5ZM12 19C9.5 19 7.29 17.738 6 15.8253C6.03 13.8633 10 12.7887 12 12.7887C13.99 12.7887 17.97 13.8633 18 15.8253C16.71 17.738 14.5 19 12 19Z"
      fill={color || 'currentColor'}
    />
  </svg>
);

const TYTimeSortCheck = ({ color, iconHeight, iconWidth }: BaseIconProps) => (
  <svg
    width={iconWidth || 10}
    height={iconHeight || 8}
    viewBox="0 0 10 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 1.38618L3.76867 8L0 4L1.30602 2.61382L3.76867 5.22763L8.69398 0L10 1.38618Z"
      fill={color || '#0058D0'}
    />
  </svg>
);

const TYCloseXMark = ({ color, iconHeight, iconWidth }: BaseIconProps) => (
  <svg
    width={iconWidth || 8}
    height={iconHeight || 8}
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.571437 1.714C0.255841 1.39841 0.255841 0.886744 0.571437 0.571155C0.887033 0.255567 1.39871 0.255568 1.71431 0.571156L7.42868 6.28538C7.74427 6.60097 7.74427 7.11264 7.42868 7.42823C7.11308 7.74382 6.6014 7.74381 6.2858 7.42823L0.571437 1.714Z"
      fill={color || '#0058D0'}
    />
    <path
      d="M6.28598 0.571423C6.60158 0.255835 7.11326 0.255835 7.42886 0.571423C7.74445 0.887011 7.74445 1.39868 7.42886 1.71427L1.71449 7.42849C1.3989 7.74408 0.887214 7.74408 0.571618 7.42849C0.256022 7.11291 0.256023 6.60124 0.571618 6.28565L6.28598 0.571423Z"
      fill={color || '#0058D0'}
    />
  </svg>
);

const TYCalendar = () => (
  <svg
    width="12"
    height="14"
    viewBox="0 0 12 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 0L3 2H2.00049C0.895919 2 0.000488281 2.89543 0.000488281 4V12C0.000488281 13.1046 0.895919 14 2.00049 14H10.0005C11.1051 14 12.0005 13.1046 12.0005 12V4C12.0005 2.89543 11.1051 2 10.0005 2H9.03255L9.03255 0H7V2H5.03255V0H3ZM7 4H9.03255H10.0005V7H2.00049V4H3H5.03255H7Z"
      fill="#ccd5e3"
    />
  </svg>
);

export const TYNotificationCheck = ({
  color,
  iconHeight,
  iconWidth,
}: BaseIconProps) => (
  <svg
    width={iconWidth || 16}
    height={iconHeight || 12}
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.99988 9.17694L14.666 0L16 1.41153L5.99988 12L0 5.64712L1.3331 4.23559L5.99988 9.17694Z"
      fill={color || '#00CC99'}
    />
  </svg>
);

export const TYPasswordSuffix = ({
  color,
  iconHeight,
  iconWidth,
}: BaseIconProps) => (
  <svg
    width={iconWidth || 10}
    height={iconHeight || 8}
    viewBox="0 0 10 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 4C9 5.46011 7.42901 6.9999 5.00025 7C3.89573 6.9999 3.00037 5.65679 3.00037 4C3.00037 2.34315 3.8958 1 5.00037 1C5.00144 1 5.00252 0.999999 5.0036 1C5.0024 1 5.0012 1 5 1C2.5711 1 1 2.53984 1 4C1 5.46016 2.5711 7 5 7C5.00008 7 5.00016 7 5.00025 7C5.00029 7 5.00033 7 5.00037 7C6.10494 7 7.00037 5.65685 7.00037 4C7.00037 2.34476 6.10668 1.00262 5.0036 1C7.43046 1.00152 9 2.54057 9 4ZM10 4C10 6.20914 7.76142 8 5 8C2.23858 8 0 6.20914 0 4C0 1.79086 2.23858 0 5 0C7.76142 0 10 1.79086 10 4Z"
      fill={color || '#A1A1AA'}
    />
  </svg>
);

export const TYQustion = ({ color, iconHeight, iconWidth }: BaseIconProps) => (
  <svg
    width={iconWidth ?? 12}
    height={iconHeight ?? 12}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.92794 3.14072C6.55806 2.91487 6.1234 2.8189 5.69281 2.86801C5.12365 2.92783 4.66934 3.17217 4.34113 3.58763C4.12145 3.86512 3.9972 4.18316 4.01308 4.53587C4.02233 4.74168 4.17864 4.89291 4.40171 4.89553C4.61168 4.898 4.78542 4.74137 4.78927 4.54096C4.79467 4.26347 4.90844 4.03639 5.12627 3.8383C5.49194 3.50608 6.1129 3.48157 6.54038 3.75351C6.75251 3.88583 6.90576 4.09453 6.96849 4.33654C7.0118 4.49641 7.01628 4.65319 6.9059 4.80427C6.77995 4.97646 6.62347 5.12323 6.46407 5.26675C6.25334 5.4559 6.04229 5.64475 5.86131 5.85703C5.69774 6.0488 5.63669 6.19896 5.59245 6.45594C5.56485 6.61704 5.57195 6.77845 5.57071 6.94016C5.57071 7.04021 5.57071 7.14057 5.57071 7.24062C5.5683 7.3193 5.59277 7.39646 5.64008 7.45937C5.74538 7.59457 5.92112 7.64436 6.10981 7.59288C6.26305 7.55125 6.37497 7.41729 6.37836 7.26051C6.38237 7.07829 6.37975 6.89576 6.3799 6.71354C6.38097 6.59607 6.41558 6.48134 6.47964 6.38287C6.59943 6.18986 6.76885 6.03431 6.93765 5.87799C7.20913 5.62656 7.35157 5.48458 7.5543 5.19707C7.72742 4.9518 7.81005 4.69327 7.77012 4.39944C7.69689 3.86404 7.42218 3.43841 6.92794 3.14072Z"
      fill={color ?? '#7E97B8'}
    />
    <path
      d="M5.99328 8.36379C5.92086 8.36291 5.849 8.37644 5.78186 8.4036C5.71473 8.43075 5.65366 8.47098 5.60222 8.52195C5.55078 8.57292 5.50998 8.63361 5.48221 8.70049C5.45444 8.76737 5.44025 8.83911 5.44046 8.91153C5.43737 9.20967 5.68974 9.46928 5.98634 9.47298C6.2925 9.47683 6.55889 9.21522 6.55966 8.90968C6.56043 8.6513 6.33058 8.34915 5.99328 8.36379Z"
      fill={color ?? '#7E97B8'}
    />
    <path
      d="M5.99992 0C2.68625 0 0 2.68625 0 5.99992C0 9.3136 2.68625 12 5.99992 12C9.3136 12 12 9.3136 12 5.99992C12 2.68625 9.3136 0 5.99992 0ZM9.83543 9.83543C8.88427 10.784 7.61403 11.3444 6.27224 11.4075C4.93044 11.4706 3.61321 11.0319 2.57722 10.1768C1.54124 9.32173 0.860712 8.11158 0.668256 6.78216C0.475801 5.45274 0.785203 4.09928 1.53617 2.98553C2.28714 1.87177 3.42587 1.07751 4.73048 0.757504C6.03509 0.437501 7.41211 0.614685 8.59321 1.25453C9.77431 1.89437 10.6749 2.95104 11.1194 4.21863C11.564 5.48621 11.5207 6.87391 10.998 8.1113C10.7257 8.75585 10.3309 9.3414 9.83543 9.83543Z"
      fill="#7E97B8"
    />
  </svg>
);

export const TYQustionFilled = ({
  color,
  iconHeight,
  iconWidth,
}: BaseIconProps) => (
  <svg
    width={iconWidth ?? 12}
    height={iconHeight ?? 12}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.99992 0C2.68625 0 0 2.68625 0 5.99992C0 9.3136 2.68625 12 5.99992 12C9.3136 12 12 9.3136 12 5.99992C12 2.68625 9.3136 0 5.99992 0ZM6.92794 3.14072C6.55806 2.91487 6.1234 2.8189 5.69281 2.86801C5.12365 2.92783 4.66934 3.17217 4.34113 3.58763C4.12145 3.86512 3.9972 4.18316 4.01308 4.53587C4.02233 4.74168 4.17864 4.89291 4.40171 4.89553C4.61168 4.898 4.78542 4.74137 4.78927 4.54096C4.79467 4.26347 4.90844 4.03639 5.12627 3.8383C5.49194 3.50608 6.1129 3.48157 6.54038 3.75351C6.75251 3.88583 6.90576 4.09453 6.96849 4.33654C7.0118 4.49641 7.01628 4.65319 6.9059 4.80427C6.77995 4.97646 6.62347 5.12323 6.46407 5.26675L6.45682 5.27326L6.45681 5.27327C6.24849 5.46025 6.04021 5.64719 5.86131 5.85703C5.69774 6.0488 5.63669 6.19896 5.59245 6.45594C5.5702 6.58586 5.5705 6.71597 5.57081 6.84629C5.57088 6.87757 5.57095 6.90886 5.57071 6.94016V7.24062C5.5683 7.3193 5.59277 7.39646 5.64009 7.45937C5.74538 7.59457 5.92112 7.64436 6.10981 7.59288C6.26305 7.55125 6.37497 7.41729 6.37836 7.26051C6.38119 7.13206 6.38072 7.00346 6.38025 6.87492V6.87489C6.38005 6.82109 6.37986 6.7673 6.3799 6.71354C6.38097 6.59607 6.41558 6.48134 6.47964 6.38287C6.59753 6.19292 6.7635 6.03925 6.92964 5.88542L6.92964 5.88542L6.93765 5.87799C7.20913 5.62656 7.35157 5.48458 7.5543 5.19707C7.72742 4.9518 7.81005 4.69327 7.77012 4.39944C7.69689 3.86404 7.42218 3.43841 6.92794 3.14072ZM5.99328 8.36379C5.92086 8.36291 5.849 8.37644 5.78186 8.40359C5.71473 8.43075 5.65366 8.47098 5.60222 8.52195C5.55078 8.57292 5.50998 8.63361 5.48221 8.70049C5.45444 8.76737 5.44025 8.83911 5.44046 8.91153C5.43737 9.20967 5.68973 9.46928 5.98634 9.47298C6.2925 9.47683 6.55889 9.21522 6.55966 8.90968C6.56043 8.6513 6.33058 8.34915 5.99328 8.36379Z"
      fill={color ?? '#7E97B8'}
    />
  </svg>
);

const TYTutorialsIcon = ({ color }: BaseIconProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill={color || 'currentColor'}
    xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z" fill={color || 'currentColor'} />
    <path d="M11.027 14.9622V14.8872V14.8241V14.8233H11.027C11.0339 14.1502 11.1022 13.6088 11.2348 13.2024C11.3669 12.7977 11.5557 12.4663 11.8033 12.2112C12.0462 11.9608 12.3368 11.731 12.6746 11.5215C12.8696 11.3988 13.0447 11.2541 13.2 11.0873C13.3535 10.9189 13.4745 10.7252 13.5631 10.5054L13.5634 10.5045C13.6544 10.2869 13.7005 10.0445 13.7005 9.77629C13.7005 9.44449 13.6251 9.16069 13.4771 8.92193C13.3277 8.68091 13.1285 8.4957 12.8786 8.36524C12.6282 8.23458 12.3495 8.16869 12.0408 8.16869C11.773 8.16869 11.515 8.22584 11.2661 8.34058C11.0211 8.45355 10.8153 8.63157 10.6488 8.87717C10.485 9.11889 10.3872 9.43959 10.3606 9.84431L10.3559 9.91439H10.2857H9H8.9215L8.92508 9.83597C8.95278 9.2293 9.10541 8.70592 9.38585 8.26878L9.38608 8.26842L9.38608 8.26842C9.66881 7.83315 10.0412 7.4998 10.5022 7.26943L10.5024 7.26933C10.9661 7.03939 11.4793 6.925 12.0408 6.925C12.6498 6.925 13.1832 7.04989 13.6384 7.30249C14.0956 7.55429 14.4493 7.90049 14.6978 8.34055C14.9499 8.78072 15.075 9.28102 15.075 9.83939C15.075 10.2324 15.0161 10.59 14.897 10.9115C14.7817 11.2319 14.6138 11.5185 14.3934 11.7709M11.027 14.9622L14.3367 11.7218M11.027 14.9622H11.102H12.3265H12.4015V14.8872V14.8247M11.027 14.9622L12.4015 14.8247M14.3934 11.7709C14.3933 11.771 14.3933 11.7711 14.3932 11.7711L14.3367 11.7218M14.3934 11.7709C14.3935 11.7709 14.3935 11.7708 14.3936 11.7707L14.3367 11.7218M14.3934 11.7709C14.1773 12.0223 13.9166 12.2442 13.6118 12.437M14.3367 11.7218C14.1259 11.9672 13.8707 12.1845 13.5714 12.3738M13.6118 12.437C13.6119 12.437 13.612 12.4369 13.612 12.4369L13.5714 12.3738M13.6118 12.437C13.3172 12.6268 13.0837 12.8253 12.9094 13.0321L12.909 13.0326C12.7364 13.2339 12.6103 13.4745 12.5314 13.7559C12.4521 14.0385 12.4083 14.3942 12.4015 14.8247M13.6118 12.437C13.6117 12.4371 13.6116 12.4371 13.6115 12.4372L13.5714 12.3738M13.5714 12.3738L12.4015 14.8247M9 9.83939C9.00115 9.81424 9.00252 9.78924 9.0041 9.76439H9V9.83939ZM9 9.83939L9.07492 9.84281C9.07497 9.84167 9.07503 9.84053 9.07508 9.83939H9ZM11.102 14.8241C11.1021 14.8201 11.1021 14.8162 11.1022 14.8122H11.102V14.8241ZM12.2537 17.9376L12.2542 17.9373L12.5459 17.5268L12.6105 17.565C12.6106 17.5648 12.6107 17.5646 12.6108 17.5644C12.7027 17.4089 12.7485 17.2381 12.7485 17.0535C12.7485 16.7747 12.6508 16.5333 12.4569 16.3335C12.2629 16.1337 12.0277 16.0321 11.7551 16.0321C11.4825 16.0321 11.2473 16.1337 11.0533 16.3335C10.8594 16.5333 10.7617 16.7747 10.7617 17.0535C10.7617 17.3324 10.8594 17.5737 11.0533 17.7735C11.2473 17.9734 11.4825 18.075 11.7551 18.075C11.9382 18.075 12.1051 18.0295 12.2537 17.9376Z" fill={color || 'currentColor'} stroke={color || 'currentColor'} strokeWidth="0.15" />
  </svg>

);

const TYRevenueIcon = ({ color }: BaseIconProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="3" width="18" height="18" rx="9" fill="none" stroke={'currentColor'} strokeWidth="2" />
    <path d="M12.0033 17C11.6241 17 11.3176 16.6908 11.3209 16.3116L11.3958 7.66895C11.399 7.29856 11.7001 7 12.0705 7C12.445 7 12.7479 7.30495 12.7453 7.67944L12.6858 16.3223C12.6832 16.6973 12.3784 17 12.0033 17ZM13.7165 10.1016C13.6745 9.73177 13.5013 9.44531 13.1969 9.24219C12.8924 9.03646 12.5092 8.93359 12.0472 8.93359C11.7165 8.93359 11.4304 8.98568 11.189 9.08984C10.9475 9.19141 10.7598 9.33203 10.626 9.51172C10.4948 9.6888 10.4291 9.89062 10.4291 10.1172C10.4291 10.3073 10.4738 10.4714 10.563 10.6094C10.6549 10.7474 10.7743 10.8633 10.9213 10.957C11.0709 11.0482 11.231 11.125 11.4016 11.1875C11.5722 11.2474 11.7362 11.2969 11.8937 11.3359L12.6811 11.5391C12.9383 11.6016 13.2021 11.6862 13.4724 11.793C13.7428 11.8997 13.9934 12.0404 14.2244 12.2148C14.4554 12.3893 14.6417 12.6055 14.7835 12.8633C14.9278 13.1211 15 13.4297 15 13.7891C15 14.2422 14.8819 14.6445 14.6457 14.9961C14.4121 15.3477 14.0722 15.625 13.626 15.8281C13.1824 16.0312 12.6457 16.1328 12.0157 16.1328C11.4121 16.1328 10.8898 16.0378 10.4488 15.8477C10.0079 15.6576 9.66273 15.388 9.41339 15.0391C9.16404 14.6875 9.02625 14.2708 9 13.7891H10.2205C10.2441 14.0781 10.3386 14.319 10.5039 14.5117C10.6719 14.7018 10.8858 14.8438 11.1457 14.9375C11.4081 15.0286 11.6955 15.0742 12.0079 15.0742C12.3517 15.0742 12.6575 15.0208 12.9252 14.9141C13.1955 14.8047 13.4081 14.6536 13.563 14.4609C13.7178 14.2656 13.7953 14.0378 13.7953 13.7773C13.7953 13.5404 13.727 13.3464 13.5906 13.1953C13.4567 13.0443 13.2743 12.9193 13.0433 12.8203C12.815 12.7214 12.5564 12.6341 12.2677 12.5586L11.315 12.3008C10.6693 12.1263 10.1575 11.8698 9.77953 11.5313C9.4042 11.1927 9.21654 10.7448 9.21654 10.1875C9.21654 9.72656 9.34252 9.32422 9.59449 8.98047C9.84646 8.63672 10.1877 8.36979 10.6181 8.17969C11.0486 7.98698 11.5341 7.89063 12.0748 7.89063C12.6207 7.89063 13.1024 7.98568 13.5197 8.17578C13.9396 8.36589 14.2703 8.6276 14.5118 8.96094C14.7533 9.29167 14.8793 9.67188 14.8898 10.1016H13.7165Z" stroke={color || 'currentColor'} />
  </svg>
);

const TYDownloadIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14 25H26" stroke="#0058D0" strokeWidth="2" strokeLinecap="round" />
    <path fillRule="evenodd" clipRule="evenodd" d="M25.3417 17.1252L20.5132 21.7803C20.229 22.0732 19.7682 22.0732 19.484 21.7803L14.4985 17.1252C14.2143 16.8323 14.2143 16.2929 14.4985 16C14.7828 15.7071 15.2862 15.7071 15.5704 16L19 19L19 12C19 11.4477 19.4477 11 20 11C20.5523 11 21 11.4477 21 12L21 19L24.2698 16C24.554 15.7071 25.0574 15.7071 25.3416 16C25.6259 16.2929 25.6259 16.8323 25.3417 17.1252Z" fill="#0058D0" />
  </svg>
);

export const Icons = {
  TYArrowDown,
  TYArrowUp,
  TYClock,
  TYDashboardIcon,
  TYDropdownArrow,
  TYDropdownDots,
  TYFilterIcon,
  TYMainLogoIcon,
  TYManagePlayersIcon,
  TYManageUsersIcon,
  TYPlusIcon,
  TYSearchIcon,
  TYSettingsIcon,
  TYUserIcon,
  TYPlayerBack,
  TYPlayerLoading,
  TYPlayerPause,
  TYPlayerForward,
  TYPlayerVolume,
  TYPlayerPlayback,
  TYPlayerPreferences,
  TYSelectIcon,
  TYNewUserIcon,
  TYCopyIcon,
  TYCopiedIcon,
  TYUserListIcon,
  TYEmailMathesIcon,
  TYShowPasswordIcon,
  TYTableDropdownIcon,
  TYTableDropdownPause,
  TYTableDropdownPlay,
  TYPublisherArrowDown,
  TYPublisherArrowUp,
  TYTableStaticType,
  TYTableDynamicType,
  TYManagePublishers,
  TYTimeSortCheck,
  TYCloseXMark,
  TYCalendar,
  TYPlayerActivateMask,
  TYPlayerDynamicClose,
  TYPlayerDynamicPreferences,
  TYNotificationCheck,
  TYPasswordSuffix,
  TYQustion,
  TYQustionFilled,
  TYTutorialsIcon,
  TYRevenueIcon,
  TYDownloadIcon
};
